import { ACTION_LOGOUT } from 'src/state/store/general/general.const';

export const actionLogout = () => {
	return {
		type: ACTION_LOGOUT,
	};
};
